import React from "react";

function StartingContent() {
    return (
        <div style={{ padding: "2rem", textAlign: "center" }}>
            <img
                src={
                    localStorage.getItem("BurchCoin") === JSON.stringify(true)
                        ? './images/Burchcoin.png'
                        : './images/BridgingHopeNoWord.svg'
                }
                className="img-fluid"
                alt="logo"
                style={{ maxHeight: "120px" }}
            />
            <h2>Welcome to Bridging Hope</h2>
            <p>
                Please select an option from the sidebar to get started. If there are no options, seek help.
            </p>
        </div>
    );
}

export default StartingContent;